module.exports = __webpack_public_path__ + "img/footer.26bc4de8.jpg";